import React from 'react';
import { Container, Typography, TextField, Button, Box } from '@mui/material';

const FansSection = () => {
  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Join the DGFC Fan Club
      </Typography>
      <Box mb={2}>
        <Typography variant="body1">Name</Typography>
        <TextField fullWidth placeholder="Enter your name" variant="outlined" />
      </Box>
      <Box mb={2}>
        <Typography variant="body1">Email</Typography>
        <TextField fullWidth placeholder="Enter your email" variant="outlined" />
      </Box>
      <Button variant="contained" color="primary" size="large">
        Submit
      </Button>
    </Container>
  );
};

export default FansSection;
